import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalData } from '@models/modal-data';
import { SharedService } from '@services/shared.service';

/**
 * launch dialog component
 * serves as a template container for the legacy user onboarding workflow.
 * The component is shown as a modal dialog to start Scope client via web interface.
 * @class LaunchDialogComponent
 * @typedef {LaunchDialogComponent}
 * @implements {OnInit}
 */
@Component({
    selector: 'app-launch-dialog',
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: './launch-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './launch-dialog.component.scss'
})
export class LaunchDialogComponent implements OnInit {
    data = inject<ModalData>(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<LaunchDialogComponent>>(MatDialogRef);

    /** reference on choosen server url */
    scopeUrl = '';

    #router = inject(Router);
    #sharedService = inject(SharedService);

    /** start scope instance */
    ngOnInit(): void {
        window.setTimeout(() => {
            this.launchScope();
        }, 125);
    }

    /** close dialog and open runtime list dialog */
    downloadRuntime() {
        this.closeDialog();
        this.#router.navigate(['/tools/scope-runtime']);
    }

    /** helper function to close dialog */
    closeDialog(): void {
        this.dialogRef.close('close');
    }

    /** helper function to launch scope manually */
    launchScope() {
        this.#sharedService.launchScope(this.data.version!, this.data.url!);
    }
}
